import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, effect, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';

interface ComplexData {
    name?: string;
    age?: number;
    address?: {
        street: string;
        city: string;
        zip: string;
    };
    friends?: string[];
}

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule
    ],
    template: `
        <div class="data-container">
            <label>Name</label>
            <div>{{data().name}}</div>
            <label>Age</label>
            <div>{{data().age}}</div>
            <label>Address</label>
            <div>{{data().address?.street}}</div>
            <label>City</label>
            <div>{{data().address?.city}}</div>
            <label>Zip</label>
            <div>{{data().address?.zip}}</div>

            @for (friend of data().friends; track friend) {
                <label>Friend</label>
                <div>{{friend}}</div>
            }
        </div>
        <div class="toolbar-horizontal">
            <button (click)="onChangeName()">Change Name</button>
        </div>
    `,
    styles: `
        @use "forms";
        div.data-container {
            @include  forms.labeled-items-panel-colon(4)
        }

    `
})
export class TestSignalsComponent {

    protected readonly data = signal<ComplexData>({});

    constructor() {
        setTimeout(() => this.initData(), 2000);
        setInterval(() => this.addFriends(), 10_000);
    }

    private initData() {
        this.data.set({
            name: 'Alexander',
            age: 30,
            address: {
                street: '123 Main St',
                city: 'Anytown',
                zip: '12345'
            },
            friends: ['Bob', 'Jane', 'John']
        });
    }

    onChangeName() {
        const data = this.data();
        data.name = 'John';
        data.age = 40;
    }

    private addFriends() {
        const data = this.data(); //structuredClone(this.data());
        const newFriend = `Alice-${Math.floor(Math.random() * 1000)}`;
        console.log('Adding friend:' + newFriend);
        data.friends?.push(newFriend);
        // this.data.set(data);
    }
}
